import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { LOGOUT, LogoutService } from '@backbase/foundation-ang/web-sdk';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { hasStatusWithHeaderValue } from '../common/helpers';

/**
 * Interceptor used to check for invalid tokens returned from service calls.
 * When an invalid token header is found the user will be logged out.
 */
@Injectable()
export class InvalidTokenInterceptor implements HttpInterceptor {
  private readonly authHeaderKey = 'www-authenticate';
  private readonly authHeaderValue = 'Bearer error="invalid_token"';
  private readonly authStatus = 401;

  // @internal
  constructor(
    @Optional()
    @Inject(LOGOUT)
    private readonly logoutService: LogoutService,
  ) {}

  // @internal
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (hasStatusWithHeaderValue(error, this.authStatus, this.authHeaderKey, this.authHeaderValue)) {
          this.handleInvalidToken();
        }
        return throwError(error);
      }),
    );
  }

  private handleInvalidToken(): void {
    this.logoutService.logout(window.location.href);
  }
}
